import Box from "@mui/material/Box";
import React, {useEffect, useMemo, useState} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {ListItemText} from "@mui/material";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import PersonalizationModal from "./PersonalizationModal";
import CustomerService from "../../../../API/customer/CustomerService";
import {country} from "../../../../data/Country";
import OrganizationService from "../../../../API/organization/OrganizationService";
import UtilityService from "../../../../API/common/UtilityService";
import CurrencyModal from "../CurrencyModal";
import CustomerOrganizationService from "../../../../API/customer/CustomerOrganizationService";
import {replaceEmptyStringsOnNull} from "../../../../utils/ReplaceEmptyStringsOnNull";
import {hasAddressContent} from "../../../../utils/customerAddressUtils";
import {
    isKuhniVersoMebelDomain,
    KUHNI_HIDDEN_CUSTOMER_PROFILE_FIELDS,
} from "../../../../utils/isKuhniVersoMebelDomain";

const CustomerSettings = ({handleModalAlert, organization, stage = 9, settings = true, name}) => {
    const [data, setData] = useState({})
    const [currencies, setCurrencies] = useState([])
    const [modal, setModal] = useState(false)
    const [modalCurrency, setModalCurrency] = useState(false)
    const [addressRefreshKey, setAddressRefreshKey] = useState(0)
    const addressText = [country[data.address?.country], data.address?.street, data.address?.houseNumber, data.address?.building, data.address?.roomNumber].filter(el => el).join(", ")
    const residentialAddressText = [country[data.residentialAddress?.country], data.residentialAddress?.street, data.residentialAddress?.houseNumber, data.residentialAddress?.building, data.residentialAddress?.roomNumber].filter(el => el).join(", ")
    const currBaseCurrency = currencies.find(el => el.id === data?.organizationSettings?.baseCurrencyId)
    const alternativeCurrency = currencies.find(el => el.id === data?.organizationSettings?.alternativeCurrencyId)
    const [loading, setLoading] = useState(false)
    const api = organization ? OrganizationService : CustomerService
    const hideCustomerProfileFields = isKuhniVersoMebelDomain() && !organization

    useEffect(() => {
        const request = !settings ? CustomerOrganizationService.getFullForCustomersOffersByName(name) : api.getAll()
        request.then(function (response) {
            setData(response.data)
        }).catch(function (error) {
            handleModalAlert(error);
        })
        organization && stage > 2 && UtilityService.getCurrencies()
            .then(function (response) {
                setCurrencies(response.data)
            }).catch(function (error) {
                handleModalAlert(error)
            })

    }, [])

    const handleClose = () => {
        setModal(false)
    }
    const handleSubmit = (res, handleClose) => {
        const {organizationSettings, address, residentialAddress, ...value} = res

        const addressId = address
            ? Number(address)
            : (hasAddressContent(data.address) ? data.address.id : null)
        const residentialAddressId = residentialAddress
            ? Number(residentialAddress)
            : (hasAddressContent(data.residentialAddress) ? data.residentialAddress.id : null)

        if (addressId == null || residentialAddressId == null) {
            handleModalAlert("Необходимо выбрать адрес и адрес доставки", "error")
            return
        }

        const payload = {
            ...replaceEmptyStringsOnNull(value),
            address: {id: addressId},
            residentialAddress: {id: residentialAddressId},
        }

        setLoading(true)
        const request = organization
            ? api.edit(payload, data?.organizationSettings?.id)
            : api.edit(payload)
        request.then(function (response) {
            setData(response.data)
            handleClose()
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const handleSubmitCurrency = (res, handleClose) => {
        setLoading(true)
        api.setCurrency(res.baseCurrencyId, res.alternativeCurrencyId).then(function (response) {
            setData(prev => ({...prev, organizationSettings: response.data}))
            handleClose()
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    return <Box sx={{display: "flex", gap: "20px", flexWrap: "wrap"}}>
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            width: "900px",
            padding: "24px",
            borderRadius: "16px",
            border: (theme) => `${theme.palette.primary.stroke} 1px solid`
        }}>
            <Box sx={{
                display: "flex"
            }}>
                <List sx={{width: '100%', maxWidth: 450,}}>
                    <ListItem>
                        <ListItemText primary={"Наименование:"} secondary={data.name || "-"}/>
                    </ListItem>
                    {!hideCustomerProfileFields && <ListItem>
                        <ListItemText primary={"Организационно-правовая форма:"}
                                      secondary={data.organizationalAndLegalForm || "-"}/>
                    </ListItem>}
                </List>
                {!hideCustomerProfileFields && <List sx={{width: '100%', maxWidth: 450}}>
                    <ListItem>
                        <ListItemText primary={"Почта:"} secondary={data.email || "-"}/>
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={"Регистрационный номер:"} secondary={data.registrationNumber || "-"}/>
                    </ListItem>
                </List>}
            </Box>
            <List sx={{width: '100%', maxWidth: 700}}>
                <ListItem>
                    <ListItemText
                        primary={"Адрес:"}
                        secondary={addressText || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText
                        primary={organization ? "Юридический адрес:" : "Адрес доставки:"}
                        secondary={residentialAddressText || "-"}/>
                </ListItem>
                {organization && <ListItem>
                    <ListItemText
                        primary={"Участие в портале"}
                        secondary={data.presenceCloud ? "Да" : "Нет"}/>
                </ListItem>}

            </List>
            {settings && <Box sx={{
                display: "flex",
                justifyContent: "end"
            }}>
                <ButtonCreate icon={false} text={"Изменить"} width={90} onClick={() => {
                    setAddressRefreshKey((key) => key + 1)
                    setModal(true)
                }}></ButtonCreate>
            </Box>}
        </Box>
        {organization && stage > 2 && <Box sx={{
            display: "flex",
            flexDirection: "column",
            width: "400px",
            height: data?.organizationSettings && (!data?.organizationSettings?.baseCurrencyId && !data?.organizationSettings?.alternativeCurrencyId) ? "210px" : "170px",
            padding: "24px",
            borderRadius: "16px",
            border: (theme) => `${theme.palette.primary.stroke} 1px solid`
        }}>
            <List sx={{width: '100%', maxWidth: 700}}>
                <ListItem>
                    <ListItemText
                        primary={"Базовая валюта:"}
                        secondary={currBaseCurrency?.curName || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText
                        primary={"Альтернативная валюта:"}
                        secondary={alternativeCurrency?.curName || "-"}/>
                </ListItem>
            </List>
            <Box sx={{
                display: "flex",
                justifyContent: "end"
            }}>
                {data?.organizationSettings && (!data?.organizationSettings?.baseCurrencyId && !data?.organizationSettings?.alternativeCurrencyId) &&
                    <ButtonCreate icon={false} text={"Добавить"} width={90}
                                  onClick={() => setModalCurrency(true)}>
                    </ButtonCreate>
                }
            </Box>
        </Box>}
        <PersonalizationModal
            open={modal}
            onClose={handleClose}
            handleSubmit={handleSubmit}
            initValue={{
                ...data,
                address: hasAddressContent(data.address) ? data.address.id : "",
                residentialAddress: hasAddressContent(data.residentialAddress) ? data.residentialAddress.id : "",
            }}
            handleModalAlert={handleModalAlert}
            organization={organization}
            hiddenFields={hideCustomerProfileFields ? KUHNI_HIDDEN_CUSTOMER_PROFILE_FIELDS : []}
            requireAddressFields={true}
            addressRefreshKey={addressRefreshKey}
            loading={loading}
        />
        {data?.organizationSettings && <CurrencyModal
            open={modalCurrency}
            onClose={() => setModalCurrency(false)}
            handleSubmit={handleSubmitCurrency}
            initValue={{
                baseCurrencyId: data?.organizationSettings?.baseCurrencyId || "",
                alternativeCurrencyId: data?.organizationSettings?.alternativeCurrencyId || ""
            }}
            handleModalAlert={handleModalAlert}
            currencies={currencies}
            loading={loading}
        />}
    </Box>
}
export default CustomerSettings